import { AppConfig, APP_CONFIG_DEFAULTS } from './common';

const APP_CONFIG: AppConfig = {
	...APP_CONFIG_DEFAULTS,
	BASE_URL: process.env.VUE_APP_BASE_URL,
	SERVICE_URL: process.env.VUE_APP_SERVICE_URL,
	REST_API_URL: process.env.VUE_APP_API_BASE_URL,
	EMIL_SERVICE_ENDPOINT: process.env.VUE_APP_EMIL_SERVICE_ENDPOINT,
	JWT_NAME: process.env.VUE_APP_JWT_NAME,
	SHOW_DEBUG_ERRORS: process.env.VUE_APP_SHOW_DEBUG_ERRORS,
	NODE_NAME: process.env.VUE_APP_NODE_NAME,
	SAML_ENABLED: process.env.VUE_APP_SAML_ENABLED == 'true' || process.env.VUE_APP_SAML_ENABLED == 'True',
	KEYCLOAK_URL: process.env.VUE_APP_KEYCLOAK_URL,
	KEYCLOAK_REALM: process.env.VUE_APP_KEYCLOAK_REALM,
	KEYCLOAK_CLIENT_ID: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
	KEYCLOAK_CLIENT_SCOPE: process.env.VUE_APP_KEYCLOAK_CLIENT_SCOPE,
};

if (process.env.VUE_APP_EDITION_TYPE != null)
	APP_CONFIG.EDITION_TYPE = process.env.VUE_APP_EDITION_TYPE;

if (process.env.VUE_APP_ROUTER_BASE != null)
	APP_CONFIG.ROUTER_BASE = process.env.VUE_APP_ROUTER_BASE;

if (process.env.VUE_APP_TIME_OUT_DURATION != null)
	APP_CONFIG.TIME_OUT_DURATION = Number(process.env.VUE_APP_TIME_OUT_DURATION);

export default APP_CONFIG;
